import { Expose } from "class-transformer";
import type { FeedbackEnum } from "../enums/feedback.enum";
import type { NegativeFeedbackReasonEnum } from "../enums/negative-feedback-reason.enum";
import type { SenderTypeEnum } from "../enums/sender-type.enum";

export interface IChatbotMessage {
  id?: number;
  senderType: SenderTypeEnum;
  text: string;
  feedback: FeedbackEnum | null;
  negativeFeedbackReason: NegativeFeedbackReasonEnum | null;
}

export class ChatbotMessage implements IChatbotMessage {
  @Expose()
  id?: number;

  @Expose()
  senderType!: SenderTypeEnum;

  @Expose({ name: "message" })
  text!: string;

  @Expose()
  feedback: FeedbackEnum | null = null;

  @Expose()
  negativeFeedbackReason: NegativeFeedbackReasonEnum | null = null;
}
